var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReferral = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#15206b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m18.1113 5.86133h-15.55558c-.58334 0-.97222.38889-.97222.97222v1.94444c0 .58334.38888.97223.97222.97223h15.55558c.5833 0 .9722-.38889.9722-.97223v-1.94444c0-.58333-.3889-.97222-.9722-.97222zm-1.9445 12.63887h-11.66664c-.58333 0-.97222-.3889-.97222-.9722v-7.77778h13.61116v7.77778c0 .5833-.3889.9722-.9723.9722z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.3335 18.5002v-12.63887"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.9304 4.5c-1.0694 1.06945-2.7222 1.36111-3.5 1.36111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.4305 5.86103s-.4861-3.01389.6806-4.27778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.9305 4.5c.7778-.77778.7778-2.13889 0-2.91667-.7778-.777774-2.0416-.777774-2.8194 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.73608 4.5c1.06945 1.06945 2.72223 1.36111 3.50002 1.36111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.2362 5.86103s.4861-3.01389-.68054-4.27778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.73617 4.5c-.77778-.77778-.77778-2.13889 0-2.91667.77777-.777774 2.04166-.777774 2.81944 0"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReferral);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/referral.b07faae30b725946f770bac54e8a0a42.svg";